import { useState, useEffect } from "react";
import { cloudinaryThumb } from "@/lib/variants";

// Immagine Cloudinary robusta: applica la trasformazione richiesta (con e_trim
// per rifilare i bordi vuoti). Se Cloudinary restituisce errore (es. e_trim
// rifila l'intera immagine su foto quasi uniformi), ripiega automaticamente
// sulla stessa trasformazione senza e_trim, che funziona sempre. Così non si
// vede mai un'immagine rotta.
export function CloudImage({ url, alt = "", transform, className, ...rest }) {
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [url, transform]);

  if (!url) return null;

  const activeTransform = errored ? transform.replace("e_trim/", "") : transform;

  return (
    <img
      src={cloudinaryThumb(url, activeTransform)}
      alt={alt}
      className={className}
      onError={() => {
        if (!errored) setErrored(true);
      }}
      {...rest}
    />
  );
}
